import styled from "styled-components";
import { message } from "@glossy";

export const Error = styled.div`
  color: ${(props) => message(props, "error")};
`;
